// extracted by mini-css-extract-plugin
export default {"root":"AppTabs_root__Nie9I"};